export class Endereco {
    cidade: String
    bairro: String
    rua: String
    numero: number
    complemento: String
    cep: String
}